import { useQuery } from "@tanstack/react-query";
import { getDashboardData, getMariaPackage, getScoutPackage, getMariaProPackage } from "src/api/dashboard";
import type { AxiosError } from "axios";

export const useDashboardData = () =>
  useQuery<API.Dashboard.getDashboardData.Response, AxiosError<API.Dashboard.getDashboardData.ErrorResponse>>({
    queryKey: ["dashboard-data"],
    queryFn: async () => {
      const response = await getDashboardData();
      return response.data;
    },
    staleTime: 1000 * 60, // Data becomes stale after 1 minute
    refetchOnWindowFocus: false, // Disable automatic refetch on window focus
    refetchOnMount: true,
    // Only refetch if the data is older than 5 minutes
    refetchInterval: 1000 * 60 * 5,
  });

export const useMariaPackage = () =>
  useQuery<API.Dashboard.getDashboardPackageData.Response, AxiosError<API.Dashboard.getDashboardPackageData.ErrorResponse>>({
    queryKey: ["maria-package"],
    queryFn: async () => {
      const response = await getMariaPackage();
      return response.data;
    },
  });

export const useScoutPackage = () =>
  useQuery<API.Dashboard.getDashboardPackageData.Response, AxiosError<API.Dashboard.getDashboardPackageData.ErrorResponse>>({
    queryKey: ["scout-package"],
    queryFn: async () => {
      const response = await getScoutPackage();
      return response.data;
    },
  });

export const useMariaProPackage = () =>
  useQuery<API.Dashboard.getDashboardPackageData.Response, AxiosError<API.Dashboard.getDashboardPackageData.ErrorResponse>>({
    queryKey: ["maria-pro-package"],
    queryFn: async () => {
      const response = await getMariaProPackage();
      return response.data;
    },
  });
